export enum UserRole {
  REGULAR = 'regular',
  ADMIN = 'admin',
  OWNER = 'owner',
  SUPER_ADMIN = 'super_admin'
}
